import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import { IChaosMonkeyConfig, IMockConfig, Mockios, resultFactory } from "./Mockios";

export class MockUtils {
    public static errorResponse<T = any>(
        request: AxiosRequestConfig,
        error: string,
        status?: number,
        statusText?: string
    ): AxiosResponse<T> {
        const errorData = {
            message: error,
        } as any;

        return {
            status: status || 500,
            statusText: statusText || "You've been hit by, you've been stuck by... A smooth monkey",
            headers: [],
            config: request,
            request,
            data: errorData as T,
        };
    }

    public static shouldChaosMonkeyAppear(config: IMockConfig, randoCalrissian: number): boolean {
        if (config.stopTheMonkey) {
            return false;
        }

        const { chaosMonkey } = config;

        return chaosMonkey && randoCalrissian < (chaosMonkey.probability || 0.1) ? true : false;
    }

    public static async chaosMonkeyResult<T = any>(
        request: AxiosRequestConfig,
        chaosMonkey: IChaosMonkeyConfig
    ): Promise<AxiosError> {
        const response: AxiosResponse<T> = await this.generateMonkeyResponse<T>(request, chaosMonkey);

        return Mockios.error(request, response);
    }

    public static generateMonkeyResponse<T = any>(request: AxiosRequestConfig, chaosMonkey: IChaosMonkeyConfig<any>) {
        const fn = chaosMonkey.whatDidTheMonkeyDo as resultFactory<T>;

        if (fn != null && typeof fn === "function") {
            return fn(request);
        }

        const errorMsg = chaosMonkey.whatDidTheMonkeyDo
            ? (chaosMonkey.whatDidTheMonkeyDo as string)
            : "Chaos monkey was here!";

        return this.errorResponse(request, errorMsg);
    }

    /**
     * delay returns a promise that will resolve after a timed delay
     *
     * @static
     * @param {number} time the number of milliseconds to delay
     */
    public static delay(time: number): Promise<any> {
        return new Promise((res) => setTimeout(() => res(), time));
    }

    public static merge(a: any, b: any) {
        if (a && b) {
            return {
                ...a,
                ...b,
            };
        }
        return a ? a : b;
    }
}
